import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, EMPTY, Observable } from 'rxjs';
import { BACKEND_URL, ORGANIZATION_REQUEST_PREFIX } from '@data-terminal/data-access/injection-tokens';
import {
    TimeRecordingSettings,
    TimeRecordingSettingsEntity,
} from '@data-terminal/shared-models/time-recording-settings';

@Injectable({
    providedIn: 'root',
})
export class SettingsTimeRecordingApiService {
    readonly #httpClient = inject(HttpClient);
    readonly #timeRecordingSettingsUrl: string = `${inject(BACKEND_URL)}${inject(ORGANIZATION_REQUEST_PREFIX)}time-recording-settings`;

    public getTimeRecordingSettings(): Observable<TimeRecordingSettingsEntity | undefined> {
        return this.#httpClient.get<TimeRecordingSettingsEntity | undefined>(this.#timeRecordingSettingsUrl);
    }

    public setTimeRecordingSettings(
        settings: TimeRecordingSettings
    ): Observable<TimeRecordingSettingsEntity | undefined> {
        return this.#httpClient
            .post<TimeRecordingSettingsEntity | undefined>(this.#timeRecordingSettingsUrl, settings)
            .pipe(catchError(() => EMPTY));
    }
}
